/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type CreateOrganizationMutationVariables = Types.Exact<{
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type CreateOrganizationMutation = {
  __typename?: 'mutation_root';
  insert_organizations_one?: { __typename?: 'organizations'; id: string } | null;
};

export const CreateOrganizationDocument = `
    mutation CreateOrganization($name: String = "") {
  insert_organizations_one(object: {name: $name}) {
    id
  }
}
    ` as string &
  TypedDocumentNode<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    CreateOrganization: build.mutation<
      CreateOrganizationMutation,
      CreateOrganizationMutationVariables | void
    >({
      query: (variables) => ({ document: CreateOrganizationDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateOrganizationMutation } = injectedRtkApi;
